import React, { useContext } from 'react';

import { FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { testId } from 'ui-components/services/testid-service';

import { CustomsContent, CustomsContentValues, LEGACY_CUSTOMS_CONTENT_TYPES } from '../../../../enums/customs-content';
import { useEnableExtendedCustomsContentTypes } from '../../../../feature-flags/hooks/use-enable-extended-customs-content-types';
import { CustomsContext } from '../../context/context';
import type { CustomsContextValue } from '../../types';

import commonStyle from '../common-style.module.less';
import { messages } from '../messages';

export const ContentTypeDropdown = () => {
  const { content, updateContentType }: CustomsContextValue = useContext(CustomsContext);
  const selectedContent = content ? CustomsContent[content] : undefined;
  const isExtendedTypesEnabled = useEnableExtendedCustomsContentTypes();

  const contentTypes = isExtendedTypesEnabled
    ? CustomsContentValues
    : CustomsContentValues.filter((ct) => LEGACY_CUSTOMS_CONTENT_TYPES.includes(ct.name));

  return (
    <DropdownMenu
      {...testId('customs-widget-contents-dropdown')}
      className={commonStyle['standard-dropdown']}
      dropdownMenuShouldHaveWidthOfButton
      fullWidth
      value={selectedContent && selectedContent.name}
      variant='form'
    >
      <DropdownMenuToggler className={commonStyle['standard-dropdown']}>
        {selectedContent ? <FormattedMessage {...selectedContent.translation} /> : <FormattedMessage {...messages.defaultContents} />}
      </DropdownMenuToggler>
      {contentTypes.map((contentType) => (
        <DropdownMenuItem
          key={contentType.name}
          onClick={() => updateContentType(contentType.name)}
          selected={selectedContent?.name === contentType.name}
        >
          <FormattedMessage {...contentType.translation} />
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};
